import gql from 'graphql-tag';

export const all = gql`{
    currencies {
        id
        name
        isoCode
        symbol
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/currency.js